import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Typography, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PlannerTriagerPanel from "./PlannerTriagerPanel";
import PlannerInstructorDialog from "./PlannerInstructorDialog";

export default function PlannerTriagerDialog({ open, onClose, moduleName }) {
  const [plannerOpen, setPlannerOpen] = useState(false);
  const [targetPaths, setTargetPaths] = useState([]);
  const [triageMessage, setTriageMessage] = useState("");

  const handlePatchPlanReady = (paths, msg) => {
    setTargetPaths(paths || []);
    if (typeof msg === "string") setTriageMessage(msg);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="lg"
        PaperProps={{ sx: { height: "90vh" } }}
      >
        <DialogTitle sx={{ pr: 6 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h6">Planner Triager</Typography>
            <Box>
              <Button
                variant="outlined"
                size="small"
                onClick={() => setPlannerOpen(true)}
                disabled={!targetPaths.length}
                sx={{ mr:1 }}
              >
                Open Planner
              </Button>
              <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 2 }}>
          <PlannerTriagerPanel
            moduleName={moduleName}
            onPatchPlanReady={handlePatchPlanReady}
          />
        </DialogContent>
      </Dialog>

      <PlannerInstructorDialog
        open={plannerOpen}
        onClose={() => setPlannerOpen(false)}
        moduleName={moduleName}
        defaultFiles={targetPaths}
        defaultMessage={triageMessage}
      />
    </>
  );
}
